import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    description,
  },
} = checkout;

const validation = [
  Yup.object().shape({
    [description.name]: Yup.string().required(description.requiredMessage),
  }),
];

export default validation;